import eventinfo   from './forms/eventinfo'
import seasondates from './forms/seasondates'
import seasonoil   from './forms/seasonoil'
import seasonsetup   from './forms/seasonsetup'
import seasonsettings     from './forms/seasonsettings'
import seasonparticipants from './forms/seasonparticipants'
import seasontemplate from './forms/seasontemplate'
import seasonranking from './forms/seasonranking'
import seasonrankings from './reducer_season'

export const reducer_forms = {
    eventinfo,
    seasonsettings,
    seasondates,
    seasonoil,
    seasonsetup,
    seasonparticipants,
    seasontemplate,
    seasonranking,
    seasonrankings
}


// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_forms.js